<template>
  <div>
    <temporary-items-table :exclude-columns="['archived_at', 'message']" :exclude-actions="['activate']"/>
    <archive-message-modal/>
  </div>
</template>

<script>
  import TemporaryItemsTable from "@/modules/items/temporary/TemporaryItemsTable";
  import {createNamespacedHelpers} from "vuex";
  import ArchiveMessageModal from "@/modules/items/temporary/ArchiveMessageModal";

  const {mapActions} = createNamespacedHelpers('temporaryItems');

  export default {
    name: "ActiveTemporaryItems",
    components: {ArchiveMessageModal, TemporaryItemsTable},
    methods: {
      ...mapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'activeInventoryItems',
        extraFilters: {is_archived: false, without_inventory: true},
      });
    }
  }

</script>
